import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { loginData } from "model/LoginModel";
import { triggerStatusMetadataLoad } from "libs/context/statusMetadataBridge";
import { triggerPermissionLoad } from "libs/context/permissionBridge";
import { triggerUserSettingsSync } from "libs/context/userSettingBridge";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState();
  const navigate = useNavigate();

  const loginUser = async (formData) => {
    setLoading(true);
    try {
      const response = await loginData(formData);
      if (response?.success) {
        setLoading(false);
        const userDatas = response?.data;
        setUserData(userDatas);
        localStorage.setItem("authUser", JSON.stringify(userDatas?.accessToken));
        localStorage.setItem("userData", JSON.stringify(userDatas));
        triggerStatusMetadataLoad({ force: true });
        await triggerUserSettingsSync();
        triggerPermissionLoad({ force: true });
        navigate("/dashboard");
      } else {
        setLoading(false);
        toast?.error(response?.Message);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.Message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAll = async () => {
      await Promise.all([]);
    };
    fetchAll();
  }, []);

  return (
    <UserContext.Provider value={{ loginUser, loading, error }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);
